import script from "./GradingTab.vue?vue&type=script&setup=true&lang=js"
export * from "./GradingTab.vue?vue&type=script&setup=true&lang=js"

import "./GradingTab.vue?vue&type=style&index=0&id=169c5be0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-169c5be0"]])

export default __exports__